/**
 * userPresenter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { TeamPresenter } from '@app/modules/teams/team-presenter';
import { niceList } from '@shared/utils/strings';
import get from 'lodash-es/get';
import moment from 'moment';

import { Presenter } from '../../presenters/presenter';
import { PersonPresenter } from '../people/person-presenter';

export class UserPresenter extends Presenter {
    get teams() {
        return this._get('teams', () => this.get('teams.data', []).map(team => TeamPresenter.attach(team)));
    }

    get teamNames() {
        return this._get('teamNames', () => niceList((this.teams || []).map(team => team.description)));
    }

    get name() {
        return this._get('name', () => get(this.person, 'name'));
    }

    get nameShort() {
        return this._get('nameShort', () => get(this.person, 'nameShort'));
    }

    get email() {
        return this.data.email;
    }

    get lastLoginMoment() {
        if (!this.data.last_login_at) {
            return null;
        }

        return this._get('lastLoginMoment', () => {
            return moment.utc(this.data.last_login_at);
        }).clone();
    }

    get lastLogin() {
        if (!this.data.last_login_at) {
            return 'Never';
        }

        return this._get('lastLogin', () => {
            return this.lastLoginMoment.local().format(Presenter.TIMESTAMP_FORMAT);
        });
    }

    get fullNameLastFirst() {
        return this._get('fullNameLastFirst', () => {
            if (this.person) {
                return this.person.fullNameLastFirst;
            }
        });
    }

    get firstName() {
        return this._get('firstName', () => {
            if (this.person) {
                return this.person.firstName;
            }
        });
    }

    get lastName() {
        return this._get('lastName', () => {
            if (this.person) {
                return this.person.lastName;
            }
        });
    }

    get person() {
        return this._get('person', () => PersonPresenter.create(this.get('person.data')));
    }

    get sessions() {
        return this.get('sessions.data');
    }

    hasRole(role) {
        return this._get(`hasRole(${role})`, () => {
            return this.get('roles.data', []).findIndex(r => r.id === role) > -1;
        });
    }
}

export default UserPresenter;
